import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from "react-router-dom";
import PlantillaScreen from '../../../helpers/PlantillaScreen';
import request from '../../../../Helpers/API';
import Swal from 'sweetalert2';
import { Button, TextField, Autocomplete, MenuItem } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { ButtonBack } from '../Util/ButtonBack';

export const SeguimientoActividadesAgregarScreen = () => {

    const history = useHistory();
    const { id } = useParams();

    const [salas, setSalas] = useState([]);
    const [salaSeleccionada, setSalaSeleccionada] = useState(null);

    const [grupos, setGrupos] = useState([]);
    const [grupoSeleccionado, setGrupoSeleccionado] = useState(null);

    const [actividadesSala, setActividadesSala] = useState([]);
    const [actividadesGrupo, setActividadesGrupo] = useState([]);
    const [actividadSeleccionada, setActividadSeleccionada] = useState(null);

    const [comentarios, setComentarios] = useState("");
    const [estatus, setEstatus] = useState("C");

    const [prioridad, setPrioridad] = useState("M"); 

    const [archivo, setArchivo] = useState(null);
    const [archivoBase64, setArchivoBase64] = useState("");
    const [evidenciaActual, setEvidenciaActual] = useState("");
    const [loading, setLoading] = useState(false);

    const usuario = 1;

    useEffect(() => {

        const init = async () => {

            try {

                const resSalas = await request.get("Sala/Listado");
                const salasData = resSalas.data ? resSalas.data : resSalas;

                setSalas(salasData);

                if (!id) return;

                const resSeguimiento = await request.get(`SeguimientoAct/Obtener/${id}`);
                const data = resSeguimiento.data ? resSeguimiento.data : resSeguimiento;

                const sala = salasData.find(
                    s => Number(s.idsala) === Number(data.idSala)
                );

                if (!sala) return;

                setSalaSeleccionada(sala);

                const resActividades = await request.get(`Actividad/ActividadesPorSala/${sala.idsala}`);
                const actividades = resActividades.data ? resActividades.data : resActividades;

                setActividadesSala(actividades);

                const gruposUnicos = [
                    ...new Map(
                        actividades.map(a => [a.idgrupoactividades, {
                            idgrupoactividades: a.idgrupoactividades,
                            nombregrupoactividades: a.nombregrupoactividades
                        }])
                    ).values()
                ];

                setGrupos(gruposUnicos);

                const actividad = actividades.find(
                    a => Number(a.idactividad) === Number(data.idActividad)
                );

                if (actividad) {

                    const grupo = gruposUnicos.find(
                        g => Number(g.idgrupoactividades) === Number(actividad.idgrupoactividades)
                    );

                    setGrupoSeleccionado(grupo);

                    const actividadesFiltradas = actividades.filter(
                        a => Number(a.idgrupoactividades) === Number(actividad.idgrupoactividades)
                    );

                    setActividadesGrupo(actividadesFiltradas);
                    setActividadSeleccionada(actividad);
                }

                setComentarios(data.comentarios || "");
                setEstatus(data.estatus || "C");
                setPrioridad(data.prioridad || "M"); 
                setEvidenciaActual(data.evidencia || "");

            } catch (error) {

                //console.log(error);
                Swal.fire("ERROR", "No se pudo cargar el seguimiento", "error");

            }

        };

        init();

    }, [id]);


    const onSeleccionarSala = async (_, value) => {

        setSalaSeleccionada(value);
        setGrupoSeleccionado(null);
        setActividadSeleccionada(null);
        setActividadesGrupo([]);

        if (!value) return;

        try {

            const res = await request.get(`Actividad/ActividadesPorSala/${value.idsala}`);
            const actividades = res.data ? res.data : res;

            setActividadesSala(actividades);

            const gruposUnicos = [
                ...new Map(
                    actividades.map(a => [a.idgrupoactividades, {
                        idgrupoactividades: a.idgrupoactividades,
                        nombregrupoactividades: a.nombregrupoactividades
                    }])
                ).values()
            ];

            setGrupos(gruposUnicos);

        } catch {

            Swal.fire("ERROR", "No se pudieron cargar actividades", "error");

        }

    };


    const onSeleccionarGrupo = (_, grupo) => {

        setGrupoSeleccionado(grupo);
        setActividadSeleccionada(null);

        if (!grupo) {
            setActividadesGrupo([]);
            return;
        }

        const filtradas = actividadesSala.filter(
            a => Number(a.idgrupoactividades) === Number(grupo.idgrupoactividades)
        );

        setActividadesGrupo(filtradas);

    };


    const convertirBase64 = (file) => {

        const reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onload = () => setArchivoBase64(reader.result);

        reader.onerror = () =>
            Swal.fire("Error", "No se pudo leer el archivo", "error");

    };


    const onSeleccionarArchivo = (e) => {

        const file = e.target.files[0];

        if (!file) return;

        setArchivo(file);
        convertirBase64(file);

    };


    const onGuardar = async () => {

        if (!salaSeleccionada) {
            Swal.fire("Aviso", "Seleccione una sala", "warning");
            return;
        }

        if (!actividadSeleccionada) {
            Swal.fire("Aviso", "Seleccione una actividad", "warning");
            return;
        }

        if (!prioridad) {
            Swal.fire("Aviso", "Seleccione una prioridad", "warning");
            return;
        }

        try {

            setLoading(true); // 🔥 MOSTRAR LOADING

            const payload = {
                idSolicitud: id ? Number(id) : 0,
                idSala: Number(salaSeleccionada.idsala),
                idActividad: Number(actividadSeleccionada.idactividad),
                comentarios: comentarios || "",
                estatus: estatus,
                usuario: Number(usuario),
                prioridad: prioridad,
                evidencia: archivoBase64 ? archivoBase64 : evidenciaActual
            };

            if (id) {
                await request.post("SeguimientoAct/Editar", payload);
                Swal.fire("Correcto", "Seguimiento actualizado correctamente", "success");
            } else {
                await request.post("SeguimientoAct/Guardar", payload);
                Swal.fire("Correcto", "Seguimiento guardado correctamente", "success");
            }

            history.push("/Permisos/CatSeguimientoActividades");

        } catch (error) {

            Swal.fire("Error", "No se pudo guardar", "error");

        } finally {

            setLoading(false); // 🔥 OCULTAR LOADING

        }
    };


    return (

        <PlantillaScreen
            titulo={id ? "EDITAR SEGUIMIENTO DE ACTIVIDAD" : "AGREGAR SEGUIMIENTO DE ACTIVIDAD"}
            className_main={1}
            className={"seguimiento-actividades-contenedor"}
        >

            <div
                className='sac-contenido'
                style={{
                    height: "calc(100vh - 140px)",
                    overflowY: "auto",
                    paddingRight: 1,
                    paddingTop: 7
                }}
            >

                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 20,
                    maxWidth: 1200
                }}>

                    <Autocomplete
                        size="small"
                        options={salas}
                        getOptionLabel={(option) => `${option.idsala} - ${option.nombresala}`}
                        value={salaSeleccionada}
                        onChange={onSeleccionarSala}
                        renderInput={(params) => (
                            <TextField {...params} label="Seleccione una Sala..." />
                        )}
                    />

                    <Autocomplete
                        size="small"
                        options={grupos}
                        getOptionLabel={(option) => `${option.idgrupoactividades} - ${option.nombregrupoactividades}`}
                        value={grupoSeleccionado}
                        onChange={onSeleccionarGrupo}
                        renderInput={(params) => (
                            <TextField {...params} label="Seleccione un Grupo..." />
                        )}
                    />

                    <Autocomplete
                        size="small"
                        options={actividadesGrupo}
                        getOptionLabel={(option) => `${option.idactividad} - ${option.nombreactividad}`}
                        value={actividadSeleccionada}
                        onChange={(_, value) => setActividadSeleccionada(value)}
                        renderInput={(params) => (
                            <TextField {...params} label="Seleccione una Actividad..." />
                        )}
                    />

                    <TextField
                        
                        label="Comentarios"
                        multiline
                        rows={4}
                        value={comentarios}
                        onChange={(e) => setComentarios(e.target.value)}
                    />

                   
                    <TextField
                        select
                        label="Prioridad"
                        value={prioridad}
                        onChange={(e) => setPrioridad(e.target.value)}
                    >
                        <MenuItem value="A">ALTA</MenuItem>
                        <MenuItem value="M">MEDIA</MenuItem>
                        <MenuItem value="B">BAJA</MenuItem>
                    </TextField>


                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>

                        <Button
                            variant="contained"
                            component="label"
                            startIcon={<UploadFileIcon />}
                        >
                            Subir Evidencia
                            <input type="file" hidden onChange={onSeleccionarArchivo} />
                        </Button>

                        {archivo && <span>{archivo.name}</span>}

                            <Button
                            variant="contained"
                            startIcon={<AddIcon />}
                            onClick={onGuardar}
                            disabled={loading}
                            style={{ width: 220 }}
                        >
                            {id ? "Actualizar Seguimiento" : "Guardar Seguimiento"}
                        </Button>

                    </div>

                    

                </div>

            </div>

            <ButtonBack path={"/Permisos/CatSeguimientoActividades"} />

            {loading && (
                <div className="overlay-loading">
                    <div className="lds-facebook">
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <p>Cargando</p>
                </div>
            )}

        </PlantillaScreen>

    );

};